module.exports = __webpack_public_path__ + "static/media/Caminho59.3e85d92a.svg";